import * as R from 'ramda'
import { useCallback, useMemo } from 'react'

import type { IFieldConfig } from 'components/formKit'
import { splitPathsByCommonPrefix } from 'components/formKit'
import { useFormOnChangeValue, useFormValues } from 'components/formKit/hooks'

export const useResetInherit = (config: IFieldConfig, configs?: IFieldConfig[]) => {
  const onChangeValue = useFormOnChangeValue()
  const values = useFormValues()

  const { isValue, parent, sharedPath, relativePaths } = useMemo(() => {
    const names = configs?.map(({ name }) => name) || [config.name]
    const { sharedPath, relativePaths } = splitPathsByCommonPrefix(names)
    const parent = R.path(sharedPath, values)
    const isValue = relativePaths.some((path) => R.path(path, parent) !== undefined)
    return { isValue, parent, sharedPath, relativePaths }
  }, [values, config, configs])

  const onReset = useCallback(() => {
    if (isValue) {
      const cbs = R.map(R.dissocPath, relativePaths) as [(p: unknown) => unknown]
      return onChangeValue?.({
        value: R.compose(...cbs)(parent),
        name: sharedPath.join('.'),
        meta: { dirty: true },
      })
    }
  }, [onChangeValue, isValue, parent, sharedPath, relativePaths])

  return [isValue, onReset] as const
}
